import styled from '@emotion/styled';
import { Flex, Input, type InputProps } from 'antd';
import type { FC } from 'react';
import { PopoverHint } from '../PopoverHint';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  size?: InputProps['size'];
  clearable?: boolean;
  additionalInfo?: string;
}

const { Search } = Input;

export const SearchBar: FC<Props> = ({
  value,
  onChange,
  placeholder = 'Search...',
  clearable = true,
  additionalInfo,
  size = 'small',
}) => {
  return (
    <Flex>
      <Search
        size={size}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%' }}
        allowClear={clearable}
      />
      {additionalInfo && (
        <StyledFormGroupHint>
          <PopoverHint>{additionalInfo}</PopoverHint>
        </StyledFormGroupHint>
      )}
    </Flex>
  );
};

const StyledFormGroupHint = styled.div`
  padding: 2px;
`;
